<!-- Menü dalı (özyinelemeli): grup -> alt grup -> yaprak -->
<ng-template #branch let-items let-depth="depth" let-inFlyout="inFlyout">
  <ng-container *ngFor="let item of items">
    <li class="m-nav__item" *ngIf="item.isActive !== false"
        (mouseenter)="onItemHover(item, $event, depth, inFlyout)"
        (mouseleave)="onItemLeave(item, depth, inFlyout)">

      <!-- alt öğesi olan grup -->
      <a *ngIf="hasItems(item)"
         href="javascript: void(0);"
         class="m-nav__link"
         [class.m-nav__link--child]="depth > 0"
         [class.is-open]="isExpanded(item) && !opensAsFlyout(item, depth, inFlyout)"
         [class.is-branch-active]="isBranchActive(item)"
         [class.m-nav__link--static]="inFlyout"
         [class.m-nav__link--flyout]="opensAsFlyout(item, depth, inFlyout)"
         [attr.title]="collapsed ? item.label : null"
         (click)="toggleItem(item, depth, inFlyout)">
        <i class="m-nav__icon {{ item.icon }}" *ngIf="item.icon"></i>
        <span class="m-nav__label">{{ item.label }}</span>
        <i class="m-nav__arrow bx"
           [ngClass]="opensAsFlyout(item, depth, inFlyout) ? 'bx-chevron-right' : 'bx-chevron-down'"></i>
      </a>

      <!-- yaprak -->
      <a *ngIf="!hasItems(item)"
         class="m-nav__link"
         [class.m-nav__link--child]="depth > 0"
         [class.is-active]="isLinkActive(item.link)"
         [attr.title]="collapsed ? item.label : null"
         [routerLink]="item.link">
        <i class="m-nav__icon {{ item.icon }}" *ngIf="item.icon"></i>
        <span class="m-nav__dot" *ngIf="!item.icon && depth > 0"></span>
        <span class="m-nav__label">{{ item.label }}</span>
        <span class="badge rounded-pill bg-{{ item.badge.variant }}" *ngIf="item.badge">{{ item.badge.text }}</span>
      </a>

      <!-- satır içi alt liste: yalnızca genişletilmiş menüdeki birinci seviye
           akordiyonu ve uçan panelin içi. Daha derin seviyeler uçan panele gider. -->
      <ul class="m-nav__sub"
          *ngIf="hasItems(item) && !opensAsFlyout(item, depth, inFlyout) && (inFlyout || isExpanded(item))">
        <ng-container *ngTemplateOutlet="branch; context: { $implicit: item.childrenMenuItem, depth: depth + 1, inFlyout: inFlyout }">
        </ng-container>
      </ul>

      <!-- hover ile açılan uçan alt menü -->
      <ul class="m-nav__sub m-nav__flyout"
          *ngIf="opensAsFlyout(item, depth, inFlyout) && isFlyoutOpen(item)"
          [style.top.px]="flyoutTop"
          [style.left.px]="flyoutLeft"
          (mouseenter)="cancelFlyoutClose()"
          (mouseleave)="scheduleFlyoutClose()">
        <li class="m-nav__flyout-title">{{ item.label }}</li>
        <ng-container *ngTemplateOutlet="branch; context: { $implicit: item.childrenMenuItem, depth: depth + 1, inFlyout: true }">
        </ng-container>
      </ul>

    </li>
  </ng-container>
</ng-template>

<aside class="m-sidebar" [class.m-sidebar--collapsed]="collapsed" [class.m-sidebar--open]="mobileOpen">

  <div class="m-sidebar__brand">
    <a routerLink="/dashboard" class="m-brand">
      <span class="m-brand__mark">{{ brandMark }}</span>
      <span class="m-brand__text">{{ subSystemName }}</span>
    </a>
  </div>

  <div class="m-sidebar__scroll">
    <ul class="m-nav">
      <li class="m-nav__item">
        <a class="m-nav__link"
           [class.is-active]="isLinkActive('/dashboard')"
           [attr.title]="collapsed ? 'Genel Bakış' : null"
           routerLink="/dashboard">
          <i class="m-nav__icon bx bx-home-circle"></i>
          <span class="m-nav__label">Genel Bakış</span>
        </a>
      </li>

      <ng-container *ngTemplateOutlet="branch; context: { $implicit: menuItems, depth: 0, inFlyout: false }"></ng-container>
    </ul>
  </div>

  <button type="button" class="m-sidebar__collapse" (click)="toggleCollapse()"
          [attr.title]="collapsed ? 'Menüyü Genişlet' : 'Menüyü Daralt'">
    <i class="bx" [ngClass]="collapsed ? 'bx-chevrons-right' : 'bx-chevrons-left'"></i>
    <span class="m-nav__label">Menüyü Daralt</span>
  </button>

</aside>
